export default "__VITE_ASSET__CLevXkUH__"